// ToggleSwitch.js
import React from "react";
import "./ToggleSwitch.css";

const ToggleSwitch = ({ value, onChange }) => {
  return (
    <label className="switch">
      <input type="checkbox" checked={value===1} onChange={onChange} />
      <span className="slider"></span>
    </label>
  );
};

export default ToggleSwitch;
